module.exports = __webpack_public_path__ + "img/university-of-hawaii-logo.906b6d59.png";